export const AVAILABILITY_STATES = Object.freeze([
  "AVAILABLE",
  "TENTATIVE",
  "UNAVAILABLE",
]);

export function normalizeAvailability(value, fallbackTimeZone = "UTC") {
  if (!Array.isArray(value)) return [];
  return value.map((entry) => {
    if (typeof entry === "string") {
      return {
        startDate: entry.slice(0, 10),
        endDate: entry.slice(0, 10),
        timeZone: fallbackTimeZone,
        state: "AVAILABLE",
        notes: "",
      };
    }
    return {
      startDate: String(entry?.startDate || entry?.startAt || "").slice(0, 10),
      endDate: String(entry?.endDate || entry?.endAt || entry?.startDate || entry?.startAt || "").slice(0, 10),
      timeZone: entry?.timeZone || entry?.timezone || fallbackTimeZone,
      state: AVAILABILITY_STATES.includes(entry?.state) ? entry.state : "AVAILABLE",
      notes: String(entry?.notes || ""),
    };
  });
}

export function validateAvailability(entries) {
  for (const entry of entries) {
    if (!entry.startDate || !entry.endDate || entry.endDate < entry.startDate) return false;
    if (!entry.timeZone || !AVAILABILITY_STATES.includes(entry.state)) return false;
    try {
      new Intl.DateTimeFormat("en", { timeZone: entry.timeZone }).format();
    } catch {
      return false;
    }
  }
  return true;
}

export function availabilityKey(entry, index = 0) {
  return `${entry.startDate}-${entry.endDate}-${entry.state}-${index}`;
}
